export const DIAGNOSIS_TYPES = [
    "ABDOMINAL_AORTIC_ANEURYSM",
    "ACIDIC_REFLUX",
    "ACUTE_APPENDICITIS",
    "ACUTE_CHOLECYSTITIS",
    "ACUTE_RENAL_FAILURE",
    "ACUTE_URINARY_RETENTION",
    "ACUTE_PSYCHOSIS",
    "ANAPHYLAXIS",
    "AORTIC_DISSECTION",
    "AORTIC_STENOSIS",
    "ATRIAL_FIBRILLATION",
    "AV_BLOCK_COMPLETE",
    "AVNRT",
    "BENIGN_PAROXYSMAL_POSITIONAL_VERTIGO",
    "CHEST_SEPSIS",
    "COMMUNITY_ACQUIRED_PNEUMONIA",
    "CONGESTIVE_HEART_FAILURE",
    "COVID_INFECTION",
    "DEPRESSION",
    "DEHYDRATION",
    "DIABETIC_COMA",
    "ECTOPIC_PREGNANCY",
    "FEBRILE_SEIZURE",
    "FOOT_FRACTURE",
    "HYPERGLYCAEMIA",
    "HYPERKALEMIA",
    "HYPERTENSIVE_CRISIS",
    "HYPERTENSIVE_EMERGENCY",
    "HYPERTHYROIDISM",
    "HYPOGLYCAEMIA",
    "NON_INFECTIVE_EXACERBATION_OF_COPD",
    "INFECTIVE_GASTROENTERITIS",
    "ISCHAEMIC_STROKE",
    "KIDNEY_STONES",
    "LEFT_SIDED_ENDOCARDITIS",
    "LIVER_CIRRHOSIS",
    "LOWER_GI_BLEEDING",
    "MENINGITIS",
    "MESENTERIC_ISCHAEMIA",
    "MIGRAINE",
    "MUSCULOSKELETAL_CHEST_PAIN",
    "NON_INFECTIVE_EXACERBATION_OF_ASTHMA",
    "INFECTIVE_EXACERBATION_OF_COPD",
    "NSTEMI",
    "ORTHOSTATIC_SYNCOPE",
    "OVARIAN_TORSION",
    "PANIC_ATTACK",
    "PERIPHERAL_ARTERY_DISEASE",
    "PNEUMOTHORAX",
    "PREECLAMPSIA",
    "PULMONARY_EMBOLISM",
    "PULMONARY_EMBOLISM_UNSTABLE",
    "SHOULDER_DISLOCATION",
    "SEIZURE",
    "SIGMOID_DIVERTICULITIS",
    "SINUS_TACHYCARDIA",
    "SINUS_VEIN_THROMBOSIS",
    "STEMI_ANTERIOR",
    "STEMI_POSTERIOR",
    "SUBARACHNOID_HEMORRHAGE",
    "SUBDURAL_HEMATOMA",
    "TESTICULAR_TORSION",
    "TRANSIENT_ISCHAEMIC_ATTACK",
    "TRAUMATIC_BRAIN_INJURY",
    "UPPER_GI_BLEED",
    "UPPER_GI_BLEED_UNSTABLE",
    "UPPER_RESPIRATORY_TRACT_INFECTION",
    "UROSEPSIS",
    "HIP_FRACTURE",
    "FEMORAL_HEAD_NECROSIS",
    "HIP_OA",
    "KNEE_OA",
    "MENISCUS_DEFECT",
    "OSTEOCHONDRAL_LESION_OF_THE_KNEE",
    "TIBIAPLATEU_FRACTURE",
    "INFECTION_OF_THE_HIP",
    "INFECTION_OF_THE_KNEE",
    "INFECTION_OF_THE_ANKLE",
    "DVT",
    "GOUT",
    "ANKLE_SPRAIN",
    "ACHILLES_TENDON_RUPTURE",
    "PJI_KNEE",
    "ANKLE_FRACTURE",
    "ACL_TEAR",
];